<template>
  <div>
    <loading v-if="isLoading" />
    <div class="messageBox" style="max-width: 920px; margin: 0 auto;">
      <div class="messageBoxRow clearfix">
        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
              <input type="text" class="messageInput" v-if="area == 1" v-model="postData.name" placeholder="*姓名" />
              <input type="text" class="messageInput" v-else v-model="postData.name" placeholder="*Name" />
          </div>
        </div>

        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
              <input type="text" class="messageInput" v-if="area == 1" v-model="postData.city" placeholder="国家/城市" />
              <input type="text" class="messageInput" v-else v-model="postData.city" placeholder="City" />
          </div>
        </div>
      </div>

      <div class="messageBoxRow clearfix">
        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
              <input type="text" class="messageInput" v-if="area == 1" v-model="postData.company" placeholder="*公司" />
              <input type="text" class="messageInput" v-else v-model="postData.company" placeholder="*Company" />
          </div>
        </div>

        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
              <input type="text" class="messageInput" v-if="area == 1" v-model="postData.phone" placeholder="*联系方式(电邮/电话)" />
              <input type="text" class="messageInput" v-else v-model="postData.phone" placeholder="*Phone number" />
          </div>
        </div>
      </div>

      <div class="messageBoxRow clearfix">
        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
              <input type="text" class="messageInput" v-if="area == 1" v-model="postData.state" placeholder="地 址" />
              <input type="text" class="messageInput" v-else v-model="postData.state" placeholder="State" />
          </div>
        </div>

        <div class="messageBoxItem">
          <div class="messageBoxItemPad">
            <div class="searchBox">

              <div class="searchHeader " @click="downClick()"  v-if="area == 1">
                <img src="@/assets/images/down.png" class="searchHeaderIcon" />
                <span class="c_c" v-if="typeListActive == -1">*请选择服务</span>
                <span v-else>{{typeList[typeListActive]}}</span>
              </div>

              <div class="searchHeader " @click="downClick()"  v-else>
                <img src="@/assets/images/down.png" class="searchHeaderIcon" />
                <span class="c_c" v-if="typeListActive == -1">*Where is your event?</span>
                <span v-else>{{typeList[typeListActive]}}</span>
              </div>


              <div class="searchDown" v-if="downOpen">
                <div class="searchDownItem" v-for="(item,index) in typeList" :class="{'active': typeListActive == index}" @click="typeListClick(index)">{{item}}</div>

                <div class="searchDownItem" v-if="!typeList[0]" @click="downOpen = false" style="text-align: center;">~No data~</div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="">
        <textarea rows="3" type="text"  v-model="postData.message" class="messageInput" v-if="area == 1" style="height: 90px; line-height: 26px; padding-top: 10px; padding-bottom: 10px;" placeholder="*您的需求" />
        <textarea rows="3" type="text"  v-model="postData.message" class="messageInput" v-else style="height: 90px; line-height: 26px; padding-top: 10px; padding-bottom: 10px;" placeholder="*Message" />
      </div>
    </div>

    <div style="padding: 50px 0 30px 0;" class="tc">
      <!-- <a href="javascript:;" class="pageMoreBtn2" style="width: 120px;" v-if="page == 'america'"><img src="@/assets/images/j.png" style="left: 45px;" />SEND</a> -->
      <a href="javascript:;" class="pageMoreBtn" style="width: 120px;" @click="submit()" v-if="area == 1"><img src="@/assets/images/j.png" style="left: 45px;" />提 交</a>
      <a href="javascript:;" class="pageMoreBtn2" style="width: 120px;" @click="submit()" v-if="area == 2"><img src="@/assets/images/j.png" style="left: 45px;" />SEND</a>
      <a href="javascript:;" class="pageMoreBtn3" style="width: 120px;" @click="submit()" v-if="area == 3"><img src="@/assets/images/j.png" style="left: 45px;" />SEND</a>
      <a href="javascript:;" class="pageMoreBtn4" style="width: 120px;" @click="submit()" v-if="area == 4"><img src="@/assets/images/j.png" style="left: 45px;" />SEND</a>
    </div>
  </div>
</template>

<script>
import loading from '@/components/loading.vue'
import { feedback } from '@/api/web'

export default {
  components:{
    loading
  },
  data () {
    return {

      typeListActive:-1,
      // typeList:['展会','博物馆','年会'],
      downOpen:false,

      postData:{
        from:'',
        show_id:'',        // 展会编号
        area:'',           // 区域
        name:'',
        phone:'',
        city:'',
        company:'',
        state:'',
        event:'',
        message:''

      },
      isLoading:false
    }
  },
  props: {
    from:'',
    area:'',
    show_id:'',
    typeList:[]
  },

  methods:{
    downClick(){
      this.downOpen = !this.downOpen
    },
    typeListClick(i){
      this.typeListActive = i
      this.downOpen = false
    },
    submit(){

      if(this.area == 1){

        if(!this.postData.name){
          alert('姓名不能为空！')
          return
        }
        // if(!this.postData.city){
        //   alert('国家/城市不能为空！')
        //   return
        // }
        if(!this.postData.company){
          alert('公司不能为空！')
          return
        }

        if(!this.postData.phone){
          alert('联系方式不能为空！')
          return
        }

        // if(!this.postData.state){
        //   alert('地址不能为空！')
        //   return
        // }

        if(this.typeListActive == '-1'){
          alert('请选择服务！')
          return
        }

        if(!this.postData.message){
          alert('请选择您的需求！')
          return
        }

      }



      this.postData.from = this.from
      this.postData.area = this.area
      this.postData.show_id = this.show_id
      this.postData.event = this.typeList[this.typeListActive]
      this.isLoading = true
      feedback(this.postData).then(res => {
        this.isLoading = false
            if(res.code == 0){
              this.postData = {
                from:'',
                show_id:'',
                area:'',
                name:'',
                phone:'',
                city:'',
                company:'',
                state:'',
                event:'',
                message:''
              }
              alert('提交成功！')
          }else{
            alert(res.message)
          }
      })


      // name:'',
      // phone:'',
      // city:'',
      // company:'',
      // state:'',
      // event:'',
      // message:"留言内容"


    },



  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/message.vue